import React, { FunctionComponent } from 'react';
import styles from './OfferDescription.module.scss';
import { Block, Typography } from 'components/elements';
import { WPSimpleArticle } from 'types/articles';
import { WPAcfOfferItem } from 'types/acf';
import DOMPurify from 'dompurify';
import { FormattedText } from 'components/presentional';

interface OwnProps {
  data: WPSimpleArticle<WPAcfOfferItem>;
}

type OfferDescriptionProps = JSX.IntrinsicElements['div'] & OwnProps;

const OfferDescription: FunctionComponent<OfferDescriptionProps> = props => {
  const {
    data: { acf, title, content },
  } = props;
  const { offerDescription } = acf;

  if (!offerDescription) {
    return null;
  }

  const { price, requirements, tags } = offerDescription;

  return (
    <Block id="offer-description" theme="white" data-module="offer-description">
      <div className={styles.wrapper}>
        <Typography
          mobile="new_neue_semibold_26"
          tablet="new_neue_semibold_26"
          desktop="new_neue_32_h1"
          as="h2"
          className={styles.title}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title.rendered) }}
        />
        {price && (
          <Typography
            mobile="neue_semibold_20"
            tablet="neue_semibold_20"
            desktop="new_neue_20_h2"
            as="h3"
            className={styles.price}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(price) }}
          />
        )}
        {tags && tags.length > 0 && (
          <div className={styles.tags}>
            {tags.map((tag, index) => (
              <span key={`offer-tag-${index}`}>{tag.tag}</span>
            ))}
          </div>
        )}
        <FormattedText className={styles.content} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content.rendered) }} />
        {requirements &&
          requirements.map(({ header, description }, index) => (
            <div key={`requirement-item-${index}`} className={styles.requirement}>
              {header && (
                <Typography
                  mobile="new_neue_semibold_26"
                  tablet="new_neue_semibold_26"
                  desktop="new_neue_32_h1"
                  as="h2"
                  className={styles.title}
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(header) }}
                />
              )}
              {description && (
                <FormattedText alternative={true} className={styles.content} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }} />
              )}
            </div>
          ))}
      </div>
    </Block>
  );
};

export default OfferDescription;
